import script from "./VerifiedJobComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./VerifiedJobComponent.vue?vue&type=script&setup=true&lang=js"

import "./VerifiedJobComponent.vue?vue&type=style&index=0&id=747f1c5b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-747f1c5b"]])

export default __exports__